/* tslint:disable */
/* eslint-disable */
/**
 * AdServer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
import { ScreenshotFromJSON, ScreenshotFromJSONTyped, ScreenshotToJSON, ScreenshotToJSONTyped, } from './Screenshot';
import { SlotTypeFromJSON, SlotTypeFromJSONTyped, SlotTypeToJSON, SlotTypeToJSONTyped, } from './SlotType';
/**
 * Check if a given object implements the Slot interface.
 */
export function instanceOfSlot(value) {
    return true;
}
export function SlotFromJSON(json) {
    return SlotFromJSONTyped(json, false);
}
export function SlotFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'slotType': json['slotType'] == null ? undefined : SlotTypeFromJSON(json['slotType']),
        'game': json['game'] == null ? undefined : json['game'],
        'transparency': json['transparency'] === undefined ? undefined : json['transparency'] === null ? null : json['transparency'],
        'dimensions': json['dimensions'] == null ? undefined : json['dimensions'],
        'description': json['description'] == null ? undefined : json['description'],
        'prompt': json['prompt'] == null ? undefined : json['prompt'],
        'screenshots': json['screenshots'] == null ? undefined : (json['screenshots'].map(ScreenshotFromJSON)),
        'subslots': json['subslots'] == null ? undefined : (json['subslots'].map(SlotFromJSON)),
    };
}
export function SlotToJSON(json) {
    return SlotToJSONTyped(json, false);
}
export function SlotToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'slotType': SlotTypeToJSON(value['slotType']),
        'game': value['game'],
        'transparency': value['transparency'],
        'dimensions': value['dimensions'],
        'description': value['description'],
        'prompt': value['prompt'],
        'screenshots': value['screenshots'] == null ? undefined : (value['screenshots'].map(ScreenshotToJSON)),
        'subslots': value['subslots'] == null ? undefined : (value['subslots'].map(SlotToJSON)),
    };
}
